import { diagnosisGridItemFrag } from '../../../../services/types/medication.types';

export const folderAnamnesisWidgetFrag = `
    id
    dateFrom
    dateTo
    updatedAt
    anamnesis
    socialAnamnesis
    nurseRecommendations
    statusPraesens
    diagnosis {
        ${diagnosisGridItemFrag}
    }
    secondaryDiagnoses {
        ${diagnosisGridItemFrag}
    }
    doctor {
        id
        name
        surname
        titleBeforeName
        titleAfterName
        email
        image
        sex
        icpOfDoctor
    }
`;
